<template>
  <div class="digitalhuman-container" @dblclick="handleDoubleClick" :class="{ 'hide-animation': robotShow }">
    <iframe
      ref="digitalhuman"
      :src="src"
      frameborder="0"
      class="digitalhuman"
      allow="microphone; camera; autoplay; encrypted-media; fullscreen"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    robotShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  mounted() {
    // 请求麦克风权限
    this.requestMicrophonePermission();
    // 监听来自iframe的消息
    window.addEventListener('message', this.handleIframeMessage);

    // 监听socket事件并转发给iframe
    // this.setupSocketEventForwarding();
  },
  methods: {
    handleDoubleClick() {
      this.$bus.$emit('robotShow', true);
    },
    async requestMicrophonePermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        console.log('麦克风权限已授予');
        // 权限授予后加载iframe
        this.$refs.digitalhuman.src = this.src;
        // 释放媒体流资源
        stream.getTracks().forEach(track => track.stop());
      } catch (err) {
        console.error('麦克风权限请求失败:', err);
        // 可以显示错误提示给用户
        alert('需要麦克风权限才能使用该功能，请在浏览器设置中启用权限。');
      }
    },

    onIframeLoad() {
      // iframe加载完成后，传递socket对象
      this.sendSocketToIframe();
    },

    sendSocketToIframe() {
      const iframe = this.$refs.digitalhuman;
      if (iframe && iframe.contentWindow && window.socket) {
        // 使用postMessage传递socket状态
        iframe.contentWindow.postMessage(
          {
            type: 'SOCKET_READY',
            socketConnected: window.socket?.connected || false,
            socketId: window.socket?.id || null,
          },
          '*',
        );
      }
    },

    handleIframeMessage(event) {
      // 处理来自iframe的消息
      if (event.data.type === 'SOCKET_EMIT') {
        // iframe请求发送socket消息
        if (window.socket) {
          window.socket.emit(event.data.eventName, event.data.data);
        }
      } else if (event.data.type === 'REQUEST_SOCKET_DATA') {
        // iframe请求socket数据
        this.sendSocketDataToIframe(event.data.requestId);
      }
    },

    sendSocketDataToIframe(requestId) {
      const iframe = this.$refs.digitalhuman;
      if (iframe && iframe.contentWindow && window.socket) {
        iframe.contentWindow.postMessage(
          {
            type: 'SOCKET_DATA_RESPONSE',
            requestId: requestId,
            data: {
              connected: window.socket.connected,
              id: window.socket.id,
            },
          },
          '*',
        );
      }
    },

    setupSocketEventForwarding() {
      // 监听socket事件并转发给iframe
      if (window.socket) {
        window.socket.on('connect', () => {
          this.forwardSocketEventToIframe('connect', {});
        });

        window.socket.on('disconnect', () => {
          this.forwardSocketEventToIframe('disconnect', {});
        });

        // 添加其他需要转发的socket事件
        window.socket.on('message', data => {
          console.log('父窗口收到 WebSocket 消息:', data);

          // 根据消息类型进行特殊处理
          switch (data.type) {
            case 'chat_processing':
              console.log('AI 开始处理消息:', data.message);
              this.forwardSocketEventToIframe('chat_processing', data);
              break;
            case 'chat_completed':
              console.log('AI 处理完成:', data.message);
              this.forwardSocketEventToIframe('chat_completed', data);
              break;
            case 'chat_completed_with_card':
              console.log('AI 处理完成（含卡片）:', data.message);
              this.forwardSocketEventToIframe('chat_completed_with_card', data);
              break;
            default:
              // 转发所有其他消息
              this.forwardSocketEventToIframe('message', data);
          }
        });

        // 可以根据需要添加更多socket事件监听
        window.socket.on('error', error => {
          this.forwardSocketEventToIframe('error', error);
        });
      }
    },

    forwardSocketEventToIframe(eventName, data) {
      const iframe = this.$refs.digitalhuman;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'SOCKET_EVENT',
            eventName: eventName,
            data: data,
          },
          '*',
        );
      }
    },
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('message', this.handleIframeMessage);
    this.$refs.digitalhuman.src = '';
  },
};
</script>

<style lang="scss" scoped>
.digitalhuman-container {
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease;
  opacity: 1;
  scale: 1;

  &.hide-animation {
    opacity: 0;
    scale: 0;
    transform-origin: bottom right;
    transition: opacity 0.5s ease, scale 0.5s ease, transform 0.5s ease;
  }
}
.digitalhuman {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  pointer-events: none;
}
</style>
